var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-369 -255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5442 1.74824 1.8039 26.3448",
    stroke: "#0098FF",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6206 1.71878 46.466 27.0945",
    stroke: "#0098FF",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1728 24.4689 24.5573 47.5791",
    stroke: "#0098FF",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3183 43.9746 42.5472 62.007",
    stroke: "#0098FF",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1924 15.2955 8.94748 33.3803",
    stroke: "#00FFCE",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4849 15.2988 33.7306 26.5445",
    stroke: "#00FFCE",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4907 36.0387 36.6215 47.5693",
    stroke: "#00FFCE",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4578 44.1972 48.2371 54.8798",
    stroke: "#00FFCE",
    strokeWidth: 4.9108,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00226 0 0 1 369 255.124)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchIcon);
export default __webpack_public_path__ + "static/media/researchIcon.3d1de00ecd281875608f0bb67ca1c07e.svg";
export { ForwardRef as ReactComponent };